export type JSONValue =
  | string
  | number
  | boolean
  | null
  | { [key: string]: JSONValue }
  | JSONValue[];

export type JSONObject = { readonly [key: string]: JSONValue };

/**
 * Coerces arbitrary values into plain JSON, dropping anything not representable
 * (functions, symbols, undefined) to null.
 *
 * Lives here rather than in agent-stream so that modules needing only this helper
 * don't transitively pull in auth and Expo native config.
 */
export function normalizeJson(value: unknown): JSONValue {
  if (value === null) return null;
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map((item) => normalizeJson(item));
  }
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>).map(([key, entry]) => [
        key,
        normalizeJson(entry),
      ]),
    );
  }
  return null;
}
